import React, { createContext, useContext } from "react";

const UserStorageContext = createContext(null);

export function UserStorageProvider({ storage, children }) {
  if (!storage) {
    throw new Error("UserStorageProvider requires authenticated user-scoped storage.");
  }

  return (
    <UserStorageContext.Provider value={storage}>
      {children}
    </UserStorageContext.Provider>
  );
}

export function useUserStorage() {
  const storage = useContext(UserStorageContext);
  if (!storage) {
    throw new Error("useUserStorage must be used within UserStorageProvider.");
  }
  return storage;
}

export function useOptionalUserStorage() {
  return useContext(UserStorageContext);
}

export default UserStorageContext;
